import React from 'react';

import styles from './userWatchlistPageStyles.scss';

import WatchlistedTickersContainer from 'buyside/components/container/UserAccount/WatchlistedTickersContainer';

const UserWatchlistPage = (): React.ReactElement => (
  <>
    <div className={styles.pageTitle}>Watchlisted Tickers</div>
    <WatchlistedTickersContainer />
  </>
);

export default UserWatchlistPage;
